/**
 * "Pending at a glance" dashboard widget — counts of items needing admin attention.
 * Drop-in on /app for super_admin / hostel_admin / school_admin.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Books, Receipt, User } from "@phosphor-icons/react";

export function PendingGlance() {
  const [counts, setCounts] = useState(null);
  useEffect(() => { api.get("/admin/pending-counts").then((r) => setCounts(r.data)).catch(() => {}); }, []);
  if (!counts) return null;
  const items = [
    { label: "Pending approvals", value: counts.approvals_pending, to: "/app/approvals", icon: ShieldCheck, accent: "warning", tid: "glance-approvals" },
    { label: "Admission drafts", value: counts.admission_drafts, to: "/app/admissions", icon: User, accent: "warning", tid: "glance-drafts" },
    { label: "Marksheets in review", value: counts.marksheets_in_review, to: "/app/marksheets", icon: Books, accent: "warning", tid: "glance-marksheets" },
    { label: "Fees pending", value: counts.fees_pending, to: "/app/reports", icon: Receipt, accent: "danger", tid: "glance-fees" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4" data-testid="pending-glance">
      {items.map((it) => {
        const Icon = it.icon;
        const colour = it.value > 0 ? (it.accent === "danger" ? "text-[var(--vs-danger)]" : "text-[var(--vs-warning)]") : "text-[var(--vs-text-secondary)]";
        return (
          <Link key={it.label} to={it.to} className="vs-card p-4 hover:border-[var(--vs-secondary)]/40 transition-colors" data-testid={it.tid}>
            <div className="flex items-center gap-2 text-xs uppercase font-mono tracking-widest text-[var(--vs-text-secondary)]">
              <Icon size={12} /> {it.label}
            </div>
            <div className={`font-display text-3xl font-semibold mt-1 ${colour}`}>{it.value}</div>
            {it.value > 0 && <Badge variant="outline" className="mt-2 text-[10px] border-[var(--vs-warning)]/40 text-[var(--vs-warning)]">needs attention →</Badge>}
          </Link>
        );
      })}
    </div>
  );
}
